import Swiper from 'swiper/dist/js/swiper.min.js';

jQuery(document).ready(function($) {
  if (!$('.result').length) {
    return;
  }

  resultsMobile($);

  $('.tabbed-slider .tab').on('click', function (e){
    e.preventDefault();

    $(this).addClass('active').siblings('.tab').removeClass('active');

    $('.tabbed-slider .slider-card').eq($(this).index()).addClass('active').siblings('.slider-card').removeClass('active');
  })

  new Swiper ('.swiper-container', {
    direction: 'vertical',
    slidesPerView: 'auto',
    mousewheel: true,
  })

});

function resultsMobile($) {

  if ($('.mobile-container .list').hasClass('hide')) {
    $('.mobile-container .see-more').removeClass('hidden');
  }

  $('.see-more').on('click', function () {
    $('.mobile-container .list').removeClass('hide');
    $('.see-more').remove();
  })

  $('.result .mobile-container .list-container .list').on(
    'click',
    function () {
      $(this).toggleClass('hover')
    }
  );

  $('.result .mobile-container .list-container .list .btn').click(
    function (e) {
      e.stopPropagation()
    }
  );
}



// WEBPACK FOOTER //
// ./scripts/blocks/results.js